export default ".fs-3{\r\n    font-size: 50px;\r\n}\r\n.text-center{\r\n    text-align: center;\r\n}";